import fetch from '@/utils/fetch';
import { getParams } from '@/utils/fetch';

export function getAgePriodGuideList(e) {

    return fetch({
        url: 'structure/childObserve/getAgePriodGuideList',
        method: 'get'
    });
}

// 新增
export function addChildLearnDevelopGuide(args) {
    const params = getParams();
    params.append('gradeLevel', args.gradeLevel);
    params.append('level', args.level);
    params.append('logoUrl', args.logoUrl);
    params.append('name', args.name);
    params.append('orderNo', args.orderNo);
    params.append('pid', args.pid);
    params.append('remark', args.remark);
    params.append('type', args.type);

    return fetch({
        url: 'structure/childObserve/addChildLearnDevelopGuide',
        method: 'POST',
        data: params
    });
}
// 编辑
export function editChildLearnDevelopGuide(args) {
    const params = getParams();
    params.append('id', args.id);
    params.append('logoUrl', args.logoUrl);
    params.append('name', args.name);
    params.append('orderNo', args.orderNo);
    params.append('remark', args.remark);

    return fetch({
        url: 'structure/childObserve/editChildLearnDevelopGuide',
        method: 'POST',
        data: params
    });
}
// 删除
export function deleteChildLearnDevelopGuideById(args) {
    const params = getParams();
    params.append('id', args.id);

    return fetch({
        url: 'structure/childObserve/deleteChildLearnDevelopGuideById',
        method: 'POST',
        data: params
    });
}
// 查询指南详细信息
export function getChildLearnDevGuideInfoById(args) {
    const params = getParams();
    params.append('id', args.id);

    return fetch({
        url: 'structure/childObserve/getChildLearnDevGuideInfoById',
        method: 'POST',
        data: params
    });
}
//
export function getAllChildGuideListByPid(args) {
    const params = getParams();
    params.append('pid', args.pid);
    params.append('type', args.type);

    return fetch({
        url: 'structure/childObserve/getAllChildGuideListByPid',
        method: 'POST',
        data: params
    });
}
//
export function findGuideWithChildListByPid(args) {
    const params = getParams();
    params.append('pid', args.pid);

    return fetch({
        url: 'structure/childObserve/findGuideWithChildListByPid',
        method: 'POST',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/watchingRecords.js